import { useState, useEffect } from 'react';
import NotificationsDropdown from './components/notifications/NotificationsDropdown';
import TicketsDropdown from './components/tickets/TicketsDropdown';
import VisaStatusDropdown from './components/visa-status/VisaStatusDropdown';
import useEnabledCountries from 'hooks/useEnabledCountries';
import { useWindowSize } from 'hooks/useWindowSize';
import * as S from '../Dropdowns.styled';
import AssessmentResults from 'views/Dashboards-B2B/components/CLIENTFLOW/assessmentResultsCard/resultsCard';
import { useParams } from 'react-router-dom';
import { Program } from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/MYCLIENTS/components/dashboard/salesOnboarding/components/Results/Results';
import api from 'api';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { transformProgramsToResults } from 'utils/transformProgramsToResults';
import { Permission } from 'api/models/response/permissions';
import PERMISSION from '../../../../../../../assets/permissions.json';

export default function Dropdowns() {
    const { permissionsList } = useSelector((state: RootState) => state.permissions);
    const { names: enabledCountryNames } = useEnabledCountries();
    const [notificationsDropdownOpen, setNotificationsDropdownOpenClose] = useState<boolean>(false);
    const [ticketsDropdownOpen, setTicketsDropdownOpenClose] = useState<boolean>(false);
    const [visaStatusDropdownOpen, setVisaStatusDropdownOpenClose] = useState<boolean>(false);
    const [width, height] = useWindowSize();
    const [mobile, setMobile] = useState(false);
    const { '*': wildcardPath } = useParams();

    const isClientAssessmentPage = wildcardPath?.includes('/assessment');
    const isClientResultsPage = wildcardPath?.includes('/results');
    const [results, setResults] = useState<Program[]>();
    const { id: clientFlowId, language_setting: language } = useSelector(
        (state: RootState) => state.user.entity
    );
    const { screen } = useSelector((state: RootState) => state.formCounter);

    useEffect(() => {
        if (width >= 769) {
            setMobile(false);
        }
        if (width < 769) {
            setMobile(true);
        }
    }, [width, height]);

    const handleOpenCloseNotificationsDropdown = () => {
        setNotificationsDropdownOpenClose(!notificationsDropdownOpen);
    };

    const handleOpenCloseTicketsDropdown = () => {
        setTicketsDropdownOpenClose(!ticketsDropdownOpen);
    };

    const handleOpenCloseVisaStatusDropdown = () => {
        setVisaStatusDropdownOpenClose(!visaStatusDropdownOpen);
    };

    useEffect(() => {
        if (notificationsDropdownOpen) {
            setTicketsDropdownOpenClose(false);
            setVisaStatusDropdownOpenClose(false);
        }
    }, [notificationsDropdownOpen]);

    useEffect(() => {
        if (ticketsDropdownOpen) {
            setNotificationsDropdownOpenClose(false);
            setVisaStatusDropdownOpenClose(false);
        }
    }, [ticketsDropdownOpen]);

    useEffect(() => {
        if (visaStatusDropdownOpen) {
            setNotificationsDropdownOpenClose(false);
            setTicketsDropdownOpenClose(false);
        }
    }, [visaStatusDropdownOpen]);

    //to populate mini result cards
    useEffect(() => {
        if (clientFlowId) {
            fetchBestScoreAssessmentResults(clientFlowId.toString(), language);
        }
    }, [clientFlowId, screen, language]);

    const fetchBestScoreAssessmentResults = async (clientId: string, lang: string) => {
        setResults([]);
        try {
            const res = await api.assessment.getTopScore(clientId, lang);
            setResults(res.data);
        } catch (e) {
            console.error(e);
        }
    };

    const visibleResults = transformProgramsToResults(results, enabledCountryNames, 2);
    const hasVisibleResults = visibleResults.some((country) => country.streams.length > 0);

    return (
        <S.DropdownContainer>
            {!isClientAssessmentPage && !isClientResultsPage && (
                <>
                    <NotificationsDropdown
                        mobile={mobile}
                        open={notificationsDropdownOpen}
                        handleOpenCloseNotificationsDropdown={handleOpenCloseNotificationsDropdown}
                    />
                    <TicketsDropdown
                        mobile={mobile}
                        open={ticketsDropdownOpen}
                        handleOpenCloseTicketsDropdown={handleOpenCloseTicketsDropdown}
                    />
                    <VisaStatusDropdown
                        open={visaStatusDropdownOpen}
                        handleOpenCloseVisaStatusDropdown={handleOpenCloseVisaStatusDropdown}
                    />
                </>
            )}
            {permissionsList.some(
                (permission: Permission) => permission?.name === PERMISSION?.VIEW
            ) &&
                isClientAssessmentPage &&
                hasVisibleResults && <AssessmentResults data={visibleResults} />}
        </S.DropdownContainer>
    );
}
